import { render } from "./IndicatorItem.vue?vue&type=template&id=b8eb10be&scoped=true"
import script from "./IndicatorItem.vue?vue&type=script&lang=js"
export * from "./IndicatorItem.vue?vue&type=script&lang=js"

import "./IndicatorItem.vue?vue&type=style&index=0&id=b8eb10be&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8eb10be"]])

export default __exports__